module.exports = __webpack_public_path__ + "static/DIN-Regular-e0185b8dd98e7dadde77c95bcc0e8b8d.ttf";